import { Route } from '@angular/router';
import { AuthGuard } from '@g99-product-web-ui/shared-service';
import { ROUTE_CONSTS } from '@g99-product-web-ui/shared-util-lib';

import { PreviewUIComponent } from './components/preview-ui/preview-ui.component';
import { NxWelcomeComponent } from './nx-welcome.component';

export const appRoutes: Route[] = [
  {
    path: ROUTE_CONSTS.PREVIEW.base,
    component: PreviewUIComponent,
  },
  {
    path: ROUTE_CONSTS.REVIEWS.base,
    component: NxWelcomeComponent,
  },
  {
    path: ROUTE_CONSTS.REDIRECT,
    loadChildren: () =>
      import('@g99-product-web-ui/core-lib').then((m) => m.CoreLibModule),
  },
  {
    path: `${ROUTE_CONSTS.USERS.base}/${ROUTE_CONSTS.USERS.emailVerification}/:token`,
    loadComponent: () =>
      import('@g99-product-web-ui/user-lib').then(
        (m) => m.EmailVerificationComponent
      ),
  },
  {
    path: ROUTE_CONSTS.USERS.base,
    loadChildren: () =>
      import('@g99-product-web-ui/user-lib').then((m) => m.UserLibModule),
    canActivate: [AuthGuard],
  },
  {
    path: ROUTE_CONSTS.CORE.base,
    loadChildren: () =>
      import('@g99-product-web-ui/core-lib').then((m) => m.CoreLibModule),
  },
  {
    path: ROUTE_CONSTS.CHATBOT.chatbot,
    loadChildren: () =>
      import('@g99-product-web-ui/chatbot-lib').then((m) => m.ChatbotLibModule),
    canActivate: [AuthGuard],
  },
  {
    path: ROUTE_CONSTS.CLINIC.base,
    loadChildren: () =>
      import('@g99-product-web-ui/clinic-lib').then((m) => m.ClinicLibModule),
    canActivate: [AuthGuard],
  },
  {
    path: ROUTE_CONSTS.BUSINESS.base,
    loadChildren: () =>
      import('@g99-product-web-ui/business-lib').then(
        (m) => m.BusinessLibModule
      ),
    canActivate: [AuthGuard],
  },

  /* --------------------------------- Review --------------------------------- */
  {
    path: ROUTE_CONSTS.REVIEWS.home,
    loadChildren: () =>
      import('@g99-product-web-ui/review-manager-lib').then(
        (m) => m.ReviewManagerLibModule
      ),
    canActivate: [AuthGuard],
  },
  /* ------------------------ Automation/Triggers route ----------------------- */
  {
    path: ROUTE_CONSTS.AUTOMATIONS.base,
    loadChildren: () =>
      import('@g99-product-web-ui/automations-lib').then(
        (m) => m.AutomationsLibModule
      ),
    canActivate: [AuthGuard],
  },
  /* --------------------------- AI Campaign route ---------------------------- */
  {
    path: ROUTE_CONSTS.AI_CAMPAIGN.base,
    loadChildren: () =>
      import('@g99-product-web-ui/ai-campaign-lib').then(
        (m) => m.AiCampaignLibModule
      ),
    canActivate: [AuthGuard],
  },
  /* --------------------------- Landing page route --------------------------- */
  {
    path: ROUTE_CONSTS.LANDINGPAGE.base,
    loadChildren: () =>
      import('@g99-product-web-ui/landing-page-lib').then(
        (m) => m.LandingPageLibModule
      ),
    canActivate: [AuthGuard],
  },
  /* ----------------------------- Template routes ---------------------------- */
  {
    path: ROUTE_CONSTS.TEMPLATES.base,
    loadChildren: () =>
      import('@g99-product-web-ui/templates-lib').then(
        (m) => m.TemplatesLibModule
      ),
    canActivate: [AuthGuard],
  },

  /* --------------------------- Form builder route --------------------------- */
  /* Public onboarding wizard — token-based, no auth required. Must precede the
     guarded form-builder route so it matches before AuthGuard runs. */
  /* Editor link (internal, edit-only) — MUST come before the client route, else
     "editor" would be captured as the :token. data.editor flips the component to
     edit-only mode (no submit; client progress untouched). */
  {
    path: `${ROUTE_CONSTS.FORM_BUILDER.base}/${ROUTE_CONSTS.FORM_BUILDER.onboardingEditor}`,
    data: { editor: true },
    loadComponent: () =>
      import('@g99-product-web-ui/form-builder-lib').then(
        (m) => m.OnboardingWizardShellComponent
      ),
  },
  {
    path: `${ROUTE_CONSTS.FORM_BUILDER.base}/${ROUTE_CONSTS.FORM_BUILDER.onboarding}`,
    loadComponent: () =>
      import('@g99-product-web-ui/form-builder-lib').then(
        (m) => m.OnboardingWizardShellComponent
      ),
  },
  {
    path: ROUTE_CONSTS.FORM_BUILDER.base,
    loadChildren: () =>
      import('@g99-product-web-ui/form-builder-lib').then(
        (m) => m.FormBuilderLibModule
      ),
    canActivate: [AuthGuard],
  },

  /* ------------------------------- Task Route ------------------------------- */
  {
    path: ROUTE_CONSTS.TASK.base,
    loadChildren: () =>
      import('@g99-product-web-ui/tasks-lib').then((m) => m.TasksLibModule),
    canActivate: [AuthGuard],
  },

  /* ----------------------------- Campaign route ----------------------------- */
  {
    path: ROUTE_CONSTS.CAMPAIGN.base,
    loadChildren: () =>
      import('@g99-product-web-ui/campagin-lib').then(
        (m) => m.CampaginLibModule
      ),
    canActivate: [AuthGuard],
  },

  /* ----------------------------- Campaign route ----------------------------- */
  {
    path: ROUTE_CONSTS.CLIFFHANGER.base,
    loadChildren: () =>
      import('@g99-product-web-ui/cliffhanger-lib').then(
        (m) => m.CliffhangerLibModule
      ),
    canActivate: [AuthGuard],
  },
  /* ----------------------------- Inbox route ----------------------------- */
  {
    path: ROUTE_CONSTS.INBOX.base,
    loadChildren: () =>
      import('@g99-product-web-ui/inbox-lib').then((m) => m.InboxLibModule),
    canActivate: [AuthGuard],
  },

  /* ----------------------------- Contacts routes ---------------------------- */
  {
    path: ROUTE_CONSTS.CONTACTS.base,
    loadChildren: () =>
      import('@g99-product-web-ui/contacts-lib').then(
        (m) => m.ContactsLibModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: ROUTE_CONSTS.REPORTS.base,
    loadChildren: () =>
      import('@g99-product-web-ui/web-analytics-report').then(
        (m) => m.WebAnalyticsReportModule
      ),
    canActivate: [AuthGuard],
  },

  /* --------------------------- Appointment Routes --------------------------- */
  {
    path: ROUTE_CONSTS.APPOINTMENTS.base,
    loadChildren: () =>
      import('@g99-product-web-ui/appointment-lib').then(
        (m) => m.AppointmentLibModule
      ),
    canActivate: [AuthGuard],
  },
  /* ------------------------------ Payment route ----------------------------- */
  {
    path: ROUTE_CONSTS.PAYMENTS.base,
    loadChildren: () =>
      import('@g99-product-web-ui/payment-lib').then((m) => m.PaymentLibModule),
    canActivate: [AuthGuard],
  },

  /* ------------------------------ SelfAssessment route ----------------------------- */
  {
    path: ROUTE_CONSTS.SelfAssessment.base,
    loadChildren: () =>
      import('@g99-product-web-ui/self-assessment-lib').then(
        (m) => m.SelfAssessmentLibModule
      ),
  },
  /* ----------------------------- FileManager lib ---------------------------- */
  {
    path: ROUTE_CONSTS.FILE_MANAGER.base,
    loadChildren: () =>
      import('@g99-product-web-ui/file-manager-lib').then(
        (m) => m.FileManagerLibModule
      ),
    canActivate: [AuthGuard],
  },
  /* ---------------------------- Social media lib ---------------------------- */
  {
    path: ROUTE_CONSTS.SOCIAL_MEDIA.base,
    loadChildren: () =>
      import('@g99-product-web-ui/social-media-lib').then(
        (m) => m.SocialMediaLibModule
      ),
    canActivate: [AuthGuard],
  },

  /* ----------------------------- API integration ---------------------------- */
  {
    path: ROUTE_CONSTS.API_INTEGRATION.base,
    loadChildren: () =>
      import('@g99-product-web-ui/api-integration').then(
        (m) => m.ApiIntegrationModule
      ),
    canActivate: [AuthGuard],
  },

  /* ----------------------------- Lead status automation ---------------------------- */
  {
    path: ROUTE_CONSTS.LEAD_STATUS_AUTOMATION.base,
    loadChildren: () =>
      import('@g99-product-web-ui/lead-status-automation').then(
        (m) => m.LeadStatusAutomationModule
      ),
    canActivate: [AuthGuard],
  },

  /* ----------------------------- Import files lib ---------------------------- */
  {
    path: ROUTE_CONSTS.IMPORT_FILES.base,
    loadChildren: () =>
      import('@g99-product-web-ui/import-files-lib').then(
        (m) => m.ImportFilesLibModule
      ),
    canActivate: [AuthGuard],
  },

  /* ----------------------------- AI Agents lib ------------------------------ */
  {
    path: ROUTE_CONSTS.AI_AGENTS.base,
    loadChildren: () =>
      import('@g99-product-web-ui/ai-agents').then((m) => m.AiAgentsModule),
    canActivate: [AuthGuard],
  },
  {
    path: ROUTE_CONSTS.AI_AGENTS.active_agents,
    loadChildren: () =>
      import('@g99-product-web-ui/ai-agents').then((m) => m.AiAgentsModule),
    canActivate: [AuthGuard],
  },

  /* ---------------------------- dental assessment ---------------------------- */
  {
    path: ROUTE_CONSTS.DENTAL_ASSESSMENT.base,
    loadChildren: () =>
      import('@g99-product-web-ui/dental-assessment').then(
        (m) => m.DentalAssessmentModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: ROUTE_CONSTS.AI_SOCIAL.base,
    loadChildren: () =>
      import('@g99-product-web-ui/ai-social-media').then(
        (m) => m.AiSocialMediaModule
      ),
    canActivate: [AuthGuard],
  },
  /* -------------------------------- AI Sales -------------------------------- */
  {
    path: ROUTE_CONSTS.AI_SALES.base,
    loadChildren: () =>
      import('@g99-product-web-ui/ai-sales').then((m) => m.AiSalesModule),
    canActivate: [AuthGuard],
  },
  {
    path: `${ROUTE_CONSTS.PUBLIC_FORM.base}/${ROUTE_CONSTS.PUBLIC_FORM.formDetails}`,
    loadChildren: () =>
      import('@g99-product-web-ui/public-form-redirect-lib').then(
        (m) => m.PublicFormRedirectLibModule
      ),
  },
  {
    path: `${ROUTE_CONSTS.EMAIL.base}/${ROUTE_CONSTS.EMAIL.unsubscribe}`,
    loadChildren: () =>
      import('@g99-product-web-ui/email-unsubscribe-lib').then(
        (m) => m.EmailUnsubscribeLibModule
      ),
  },
];
